import * as types from './actionTypes';

export const modifyDate = (date) => ({
    type: types.ACTIVE_MONTH,
    payload: date,
});
